import a from"react";import{useLatestValue as n}from"./use-latest-value.js";let o=function(t){let e=n(t);return a.useCallback((...r)=>e.current(...r),[e])};export{o as useEvent};
